import { legacy_createStore as createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk"

import { mainReducer } from "./mainReducer";

const useStorage = localStorage.getItem("user")? JSON.parse(localStorage.getItem("user")):null;
const initialState = {
  
  login:useStorage,
 
  
};
const store = createStore(
  mainReducer,
  initialState,
  applyMiddleware(thunk)
);

export default store;
